import { useQuery } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { Domain } from '@pepper/utils/src/types/seo'

interface Parameter {
  data: {
    companyId?: string
    projectId?: string
  }
}

interface Response {
  domain: Domain
  total_topics: number
}

export async function getProjectDomain(data: Parameter['data']) {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${data.companyId}/projects/v2/${data.projectId}`
  try {
    const response = await axios.get(url)
    return extract.data<Response>(response).data
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function useGetProjectDomain({ data }: Parameter) {
  return useQuery({
    queryKey: ['project-domain', data.companyId, 'project', data.projectId],
    queryFn: () => getProjectDomain(data),
    enabled: data.companyId && data.projectId ? true : false,
    retry: false
  })
}
